import MJSONScreenshot from '@admin/components/mjson_screenshot'
import T from '@admin/components/t'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (entity) => ({
  engine: 'mjson',
  entity: `maha_provider_notices/${entity.code}`,
  width: 100,
  height: 75,
  screenshoted_at: entity.screenshoted_at
})

const ProviderNoticeToken = ({ provider_notice }) => (
  <div className="campaign-token">
    <div className="campaign-token-preview">
      <div className="campaign-token-preview-inner">
        <MJSONScreenshot { ...getScreenshot(provider_notice) } />
      </div>
    </div>
    <div className="campaign-token-label">
      <div className="token-link">
        <T text={ provider_notice.notice.title } />
      </div>
      <div className="token-stats">
        <T text={ provider_notice.notice.description } />
      </div>
    </div>
  </div>
)

ProviderNoticeToken.propTypes = {
  provider_notice: PropTypes.object
}

export default ProviderNoticeToken